
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import Textarea from 'components/react-validation/components/text-area';
import TagsInput from 'components/tag-input';
import * as Vali from 'helper/validator-helper';
import NumberInput from 'components/number-input';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import '../assignee-note.css';

const TAGS_LIST = [9, 13, 188];

export class AssigneeNotice extends Component {
  static propTypes = {
    assigneeNotice: PropTypes.any,
    onSaveAssigneeNotice: PropTypes.func
  }
  constructor(props) {
    super(props);
    this.state = {
      items: props.assigneeNotice,
      inputProps: { 'placeholder': 'Type email address' },
      second: false,
      third: false,
      fourth: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.assigneeNotice && nextProps.assigneeNotice.length > 0) {
      this.setState({
        items: nextProps.assigneeNotice,
        second: nextProps.assigneeNotice[1].enable,
        third: nextProps.assigneeNotice[2].enable,
        fourth: nextProps.assigneeNotice[3].enable
      });
    }
  }

  onChecked = (type) => {
    switch (type) {
      case 'second':
        if (this.state.second) {
          this.setState({
            second: !this.state.second,
            third: false,
            fourth: false
          });
        } else {
          this.setState({
            second: !this.state.second
          });
        }
        break;
      case 'third':
        if (this.state.third) {
          this.setState({
            fourth: !this.state.third,
            third: false
          });
        } else {
          this.setState({
            third: !this.state.third
          });
        }
        break;
      case 'fourth':
        this.setState({
          fourth: !this.state.fourth
        });
        break;
      default:
        break;
    }
  }

  mapParam() {
    let values = this.form.getValues();
    let data = [{
      content: values.notice[0],
      order: 1,
      sendAfter: 0,
      emails: this.state.items[0].emails,
      enable: true
    }, {
      content: values.notice[1],
      order: 2,
      sendAfter: this.numberInput2.state.value,
      emails: this.state.items[1].emails,
      enable: this.state.second
    }, {
      content: values.notice[2],
      order: 3,
      sendAfter: this.numberInput3.state.value,
      emails: this.state.items[2].emails,
      enable: this.state.third
    }, {
      content: values.notice[3],
      order: 4,
      sendAfter: this.numberInput4.state.value,
      emails: this.state.items[3].emails,
      enable: this.state.fourth
    }];

    return data;
  }

  onSubmit(e) {
    e.preventDefault();
    let values = this.form.getValues();
    let postData = [{
      content: values.notice[0],
      order: 1,
      sendAfter: 0,
      emails: this.state.items[0].emails.filter(item => this.onValidateEmail(item)).toString(),
      enable: true
    }];

    postData.push({
      content: values.notice[1],
      order: 2,
      sendAfter: this.numberInput2.state.value,
      emails: this.state.items[1].emails.filter(item => this.onValidateEmail(item)).toString(),
      enable: this.state.second
    });

    postData.push({
      content: values.notice[2],
      order: 3,
      sendAfter: this.numberInput3.state.value,
      emails: this.state.items[2].emails.filter(item => this.onValidateEmail(item)).toString(),
      enable: this.state.third
    });

    postData.push({
      content: values.notice[3],
      order: 4,
      sendAfter: this.numberInput4.state.value,
      emails: this.state.items[3].emails.filter(item => this.onValidateEmail(item)).toString(),
      enable: this.state.fourth
    });

    this.props.onSaveAssigneeNotice(postData);
  }

  handleChange(tags, index) {

    let items = this.mapParam();

    items[index].emails = tags;

    this.setState({ items: items });

  }

  onKeyUpNumber(e) {

    let elm = $(e.target);

    if (Number(elm.val()) > 100) {
      $(e.target).val(100);
      return;
    }

    if (Number(elm.val()) < 0 || Number(elm.val()) === 0) {
      $(e.target).val(0);
      return;
    }
  }

  onValidateEmail = (value) => {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    if (emailPattern.test(value.trim())) {
      return true;
    }
    return false;
  }

  onRenderTag(props) {

    let { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props;

    // let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;

    let value = getTagDisplayValue(tag);

    // if (emailPattern.test(value)) { other.className = 'react-tagsinput-tag'; }

    // else { other.className = 'react-tagsinput-tag-error'; }

    if (this.onValidateEmail(value)) { other.className = 'react-tagsinput-tag'; }

    else { other.className = 'react-tagsinput-tag-error'; }

    return <span key={key} {...other}>
      {getTagDisplayValue(tag)}
      {!disabled &&
        <a className={classNameRemove} onClick={() => onRemove(key)} />
      }
    </span>;
  }

  render() {
    let firstNotice = this.props.assigneeNotice[0].content;
    let secondNotice = this.props.assigneeNotice[1].content;
    let thirdNotice = this.props.assigneeNotice[2].content;
    let fourthNotice = this.props.assigneeNotice[3].content;
    if (this.form && this.form.getValues().notice) {
      if (this.form.getValues().notice[0]) {
        firstNotice = this.form.getValues().notice[0];
      }
      if (this.form.getValues().notice[1]) {
        secondNotice = this.form.getValues().notice[1];
      }
      if (this.form.getValues().notice[2]) {
        thirdNotice = this.form.getValues().notice[2];
      }
      if (this.form.getValues().notice[3]) {
        fourthNotice = this.form.getValues().notice[3];
      }
    }

    return (
      <div className='block assigneeNote'>
        <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
          <div className='row'>
            <div className='col-md-5'>
              <div className='boxinf'>
                <p className='noteTitle'>First notice <span className='text-danger'>*</span></p>
                <div className='inputTxt'>
                  <p className='txtinfo'>Message Text</p>
                  <Textarea name='notice'
                    value={firstNotice}
                    ref='notice'
                    className='form-control'
                    max='500'
                    maxLength='500'
                    row='8'
                    errorMsg='First notice is maximum 500 characters'
                    validations={[Vali.required, Vali.maxlength]} />
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              <p className='txtinfo centerNote'>sent right after a work order is opened.</p>
            </div>
            <div className='col-md-4 endRow'>
              <p className='txtinfo'>Also send notices to</p>
              <TagsInput value={Array.isArray(this.state.items[0].emails) ? this.state.items[0].emails : this.state.items[0].emails.split(',')}
                onChange={(tags) => {
                  this.handleChange(tags, 0);
                }}
                onlyUnique={true}
                inputProps={this.state.inputProps}
                addKeys={TAGS_LIST}
                renderTag={this.onRenderTag.bind(this)} />
            </div>
          </div>
          <div className='rowPage bottomPage row'>
            <div className='col-md-5'>
              <div className='boxinf'>
                <CheckBoxSingle
                  checked={this.state.second}
                  isRebind='true'
                  ref={c => { this.second = c; }}
                  name='second'
                  label='Second notice'
                  className='checkbox-default noteTitle'
                  onChecked={() => this.onChecked('second')} />
                {/*<p className='noteTitle'>Second notice</p>*/}
                <div className='inputTxt'>
                  <Textarea name='notice'
                    value={secondNotice}
                    ref='notice'
                    className='form-control'
                    max='500'
                    maxLength='500'
                    row='8'
                    errorMsg='Second notice is maximum 500 characters'
                    disabled={!this.state.second}
                    validations={[Vali.maxlength]} />
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              <p className='txtinfo topNote'># of days after the previous notice.</p>
              <NumberInput
                ref={c => { this.numberInput2 = c; }}
                value={this.state.items[1].sendAfter}
                disabled={!this.state.second}
                min={1}
                max={100} />
            </div>
            <div className='col-md-4 endRow'>
              <TagsInput value={Array.isArray(this.state.items[1].emails) ? this.state.items[1].emails : this.state.items[1].emails.split(',')}
                onChange={(tags) => {
                  this.handleChange(tags, 1);
                }}
                inputProps={this.state.inputProps}
                addKeys={TAGS_LIST}
                onlyUnique={true}
                disabled={!this.state.second}
                renderTag={this.onRenderTag.bind(this)} />
            </div>
          </div>
          <div className='bottomPage row'>
            <div className='col-md-5'>
              <div className='boxinf'>
                <CheckBoxSingle
                  checked={this.state.third}
                  isRebind='true'
                  disabled={!this.state.second}
                  ref={c => { this.third = c; }}
                  name='third'
                  label='Third notice'
                  className='checkbox-default noteTitle'
                  onChecked={() => this.onChecked('third')} />
                <div className='inputTxt'>
                  <Textarea name='notice'
                    ref='notice'
                    value={thirdNotice}
                    className='form-control'
                    max='500'
                    maxLength='500'
                    row='8'
                    disabled={!this.state.third}
                    errorMsg='Third notice is maximum 500 characters'
                    validations={[Vali.maxlength]} />
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              <NumberInput
                ref={c => { this.numberInput3 = c; }}
                value={this.state.items[2].sendAfter}
                disabled={!this.state.third}
                min={1}
                max={100} />
            </div>
            <div className='col-md-4 endRow'>
              <TagsInput
                value={Array.isArray(this.state.items[2].emails) ? this.state.items[2].emails : this.state.items[2].emails.split(',')}
                onChange={(tags) => {
                  this.handleChange(tags, 2);
                }}
                addKeys={TAGS_LIST}
                disabled={!this.state.third}
                onlyUnique={true}
                inputProps={this.state.inputProps}
                renderTag={this.onRenderTag.bind(this)} />
            </div>
          </div>
          <div className='bottomPage row'>
            <div className='col-md-5'>
              <div className='boxinf'>
                <CheckBoxSingle
                  checked={this.state.fourth}
                  isRebind='true'
                  ref={c => { this.fourth = c; }}
                  name='fourth'
                  label='Fourth notice'
                  disabled={!this.state.third}
                  className='checkbox-default noteTitle'
                  onChecked={() => this.onChecked('fourth')} />
                <div className='inputTxt'>
                  <Textarea name='notice'
                    ref='notice'
                    value={fourthNotice}
                    className='form-control'
                    max='500'
                    maxLength='500'
                    row='8'
                    disabled={!this.state.fourth}
                    errorMsg='Fourth notice is maximum 500 characters'
                    validations={[Vali.maxlength]} />
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              <NumberInput
                ref={c => { this.numberInput4 = c; }}
                value={this.state.items[3].sendAfter}
                disabled={!this.state.fourth}
                min={1}
                max={100} />
            </div>
            <div className='col-md-4 endRow'>
              <TagsInput
                value={Array.isArray(this.state.items[3].emails) ? this.state.items[3].emails : this.state.items[3].emails.split(',')}
                onChange={(tags) => {
                  this.handleChange(tags, 3);
                }}
                inputProps={this.state.inputProps}
                addKeys={TAGS_LIST}
                onlyUnique={true}
                disabled={!this.state.fourth}
                renderTag={this.onRenderTag.bind(this)} />
            </div>
          </div>
          <div className='form-group'>
            <Submit className='btn btn-primary btn-siteone'>Save</Submit>
          </div>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Setting/Components/assignee-notice.js